import React from 'react';

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4" onClick={onClose}>
      <div 
        className="bg-navy-blue p-8 rounded-lg shadow-2xl w-full max-w-3xl relative text-light-blue max-h-[90vh] overflow-y-auto" 
        onClick={(e) => e.stopPropagation()}
        style={{ scrollbarWidth: 'thin', scrollbarColor: '#415A77 #1B263B' }} // For Firefox
      >
        <style>
            {`
              .privacy-modal-content::-webkit-scrollbar {
                width: 8px;
              }
              .privacy-modal-content::-webkit-scrollbar-track {
                background: #1B263B;
              }
              .privacy-modal-content::-webkit-scrollbar-thumb {
                background-color: #415A77;
                border-radius: 4px;
              }
            `}
        </style>

        <button onClick={onClose} className="absolute top-4 right-4 text-light-blue hover:text-off-white text-3xl font-light z-10">&times;</button>
        
        <div className="privacy-modal-content">
          <h2 className="text-3xl font-bold mb-4 text-off-white">Privacy Policy</h2>
          <p className="text-sm text-steel-blue">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <p className="mt-4">
            Welcome to the BTC Gain & Loss Calculator. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
          </p>

          <h3 className="text-xl font-bold mt-6 mb-2 text-off-white">1. Information We Collect</h3>
          <p>We may collect information about you in a variety of ways:</p>
          <ul className="list-disc pl-5 space-y-2 mt-2">
            <li>
              <strong>Personal Data:</strong> When you register for an account, we collect personally identifiable information, such as your username, email address, and an encrypted version of your password.
            </li>
            <li>
              <strong>User-Generated Data:</strong> We store the price alerts you create, which include your target price, currency, and condition.
            </li>
            <li>
              <strong>Derivative Data:</strong> Our servers may automatically collect information when you access the site, such as your IP address, browser type, and operating system, for security and operational purposes.
            </li>
          </ul>

          <h3 className="text-xl font-bold mt-6 mb-2 text-off-white">2. Use of Your Information</h3>
          <p>Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you to:</p>
          <ul className="list-disc pl-5 space-y-2 mt-2">
            <li>Create and manage your account.</li>
            <li>Provide browser-based price alert notifications.</li>
            <li>Monitor and analyze usage and trends to improve your experience with the site.</li>
          </ul>

          <h3 className="text-xl font-bold mt-6 mb-2 text-off-white">3. Advertising and Cookies</h3>
          <p>We use third-party advertising companies, including Google, to serve ads when you visit the Site. These companies may use information about your visits to this and other websites that are contained in web cookies in order to provide advertisements about goods and services of interest to you.</p>
          <ul className="list-disc pl-5 space-y-2 mt-2">
            <li>Third party vendors, including Google, use cookies to serve ads based on a user's prior visits to our website or other websites.</li>
            <li>Google's use of advertising cookies enables it and its partners to serve ads to your users based on their visit to our site and/or other sites on the Internet.</li>
            <li>
              Users may opt out of personalized advertising by visiting{' '}
              <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-btc-orange hover:underline">Google's Ads Settings</a>.
            </li>
            <li>
              Alternatively, you can opt out of a third-party vendor's use of cookies for personalized advertising by visiting{' '}
              <a href="http://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer" className="text-btc-orange hover:underline">www.aboutads.info/choices</a>.
            </li>
          </ul>
          <p className="mt-2">For more information on how we use cookies, you can manage your preferences via the "Cookie settings" link in the banner at the bottom of the page.</p>

          <h3 className="text-xl font-bold mt-6 mb-2 text-off-white">4. Contact Us</h3>
          <p>If you have questions or comments about this Privacy Policy, please contact us at: <span className="text-btc-orange">fulminetto14@gmail.com</span>.</p>
        </div>
        
        <div className="text-right mt-8 pt-4 border-t border-steel-blue">
            <button
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-btc-orange text-dark-blue hover:bg-orange-400 transition-colors font-semibold"
            >
              Close
            </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;